import { render, staticRenderFns } from "./template.vue?vue&type=template&id=0ac1d0c1&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./template.vue?vue&type=style&index=0&id=0ac1d0c1&prod&lang=scss"
import style1 from "./template.vue?vue&type=style&index=1&id=0ac1d0c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1d0c1",
  null
  
)

export default component.exports